import React from "react";
import { Text, Image, Subtitle1, mergeClasses } from "@fluentui/react-components";
import { useStyles } from "./NoResultsMessageStyles";
import noResults from "../../../images/empty_state.png";

interface NoResultsMessageProps {
  primaryMessage: string;
  secondaryMessage?: string;
  isOrderHistoryVisible?: boolean;
}

export const NoResultsMessage: React.FC<NoResultsMessageProps> = ({
  primaryMessage,
  secondaryMessage = "",
  isOrderHistoryVisible = false,
}: NoResultsMessageProps) => {
  const styles = useStyles();

  return (
    <div
      className={
        isOrderHistoryVisible ? mergeClasses(styles.container, styles.fullWidth) : styles.container
      }
      data-testid="noResultsMessage"
    >
      <Image className={styles.image} src={noResults} alt="No results" />
      <Subtitle1 align={"center"}>{primaryMessage}</Subtitle1>
      <Text align={"center"}>{secondaryMessage}</Text>
    </div>
  );
};
